import { configureUnauthenticatedAPI } from '../configuration/unauthenticated'
import { AxiosApi } from './axiosApi'

export class UnauthenticatedAPI extends AxiosApi {
  constructor({ domain }: { domain: string }) {
    super(configureUnauthenticatedAPI(domain))
  }
}
